import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { feeIdFactory, feeIdZodSchema } from "@@/shared/financials/fees/fee-id";
import { priceZodSchema } from "@@/shared/prices/price";
import { translatableZodSchema } from "@@/shared/translations/translation";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { Except } from "type-fest";
import { z } from "zod";

const customFeeZodObject = z.object({
    _id: feeIdZodSchema,
    _type: z.literal("CUSTOM_FEE"),
    _createdAt: isoAndUnixZodSchema,
    _createdBy: userIdZodSchema,
    title: translatableZodSchema,
    price: priceZodSchema,
    description: translatableZodSchema.optional(),
});

type CustomFee = z.infer<typeof customFeeZodObject>;

type FactoryParams = Except<CustomFee, "_type" | "_id" | "_createdAt">;
const customFeeFactory = (params: FactoryParams): CustomFee => {
    return {
        ...params,
        _type: "CUSTOM_FEE",
        _id: feeIdFactory(),
        _createdAt: nowIsoAndUnix(),
    };
};

const isCustomFee = (fee: unknown): fee is CustomFee => {
    return (fee as CustomFee)?._type === "CUSTOM_FEE";
};

export { customFeeFactory, customFeeZodObject, isCustomFee };
export type { CustomFee };
